<template>
	<!-- 设置界面 -->
	<XModal ref="modal" title="终端设置" okText="保存" :ok="submit">
		<AFormModel ref="settingForm" :model="formData" :rules="rules" :label-col="{ span: 6}"
			:wrapper-col="{ span: 18}">
			<AFormModelItem label="服务器地址" prop="serverIp">
				<AInput :size="size" placeholder="例：125.124.151.131为空采用代理模式" v-model="formData.serverIp"></AInput>
			</AFormModelItem>
			<AFormModelItem label="服务器端口" prop="serverPort">
				<AInput :size="size" placeholder="例：8101" v-model="formData.serverPort"></AInput>
			</AFormModelItem>
			<AFormModelItem label="三品服务器地址" prop="thirdgrade">
				<AInput :size="size" placeholder="例：125.124.151.131:8101为空采用服务器地址" v-model="formData.thirdgrade"></AInput>
			</AFormModelItem>
			<AFormModelItem label="启用MQTT" prop="pushPort">
				<ASwitch v-model="formData.enableMqtt" />
			</AFormModelItem>
			<AFormModelItem label="消息推送端口" prop="pushPort">
				<AInput :size="size" placeholder="例：15674" v-model="formData.pushPort"></AInput>
			</AFormModelItem>
			<AFormModelItem label="终端名称" prop="deviceName">
				<AInput :size="size" placeholder="例：终端-001" v-model="formData.deviceName"></AInput>
			</AFormModelItem>
			<AFormModelItem label="标识符" prop="mac">
				<AInput :size="size" v-model="formData.mac" disabled></AInput>
			</AFormModelItem>
			<AFormModelItem label="版本号">
				<AInput :size="size" :value="require('/package.json').version" disabled></AInput>
			</AFormModelItem>
			<AFormModelItem label="布局">
				<ARadioGroup name="radioGroup" v-model="formData.layout">
					<ARadio value="1">默认</ARadio>
					<ARadio value="2">下置</ARadio>
				</ARadioGroup>
			</AFormModelItem>
		</AFormModel>
	</XModal>
</template>
<script>
	export default {
		props: {},
		data() {
			return {
				size: 'large',
				formData: {
					serverIp: null,
					thirdgrade:null,
					enableMqtt: false,
					serverPort: null,
					pushPort: null,
					deviceName: null,
					mac: null,
					layout: null
				},
				rules: {
					serverPort: [{
						required: true,
						message: '请输入服务器端口',
						trigger: 'blur'
					}, ],
					pushPort: [{
						required: true,
						message: '请输入消息推送端口',
						trigger: 'blur'
					}, ],
					deviceName: [{
						required: true,
						message: '请输入设备名称',
						trigger: 'blur'
					}, ],
				},
			};
		},
		computed: {},
		mounted() {},
		methods: {
			open() {
				this.formData.serverIp = localStorage.getItem("serverIp")
				this.formData.thirdgrade = localStorage.getItem("thirdgrade")
				this.formData.enableMqtt = localStorage.getItem("enableMqtt") == 'true' ? true : false
				this.formData.serverPort = localStorage.getItem("serverPort") || 8101
				this.formData.pushPort = localStorage.getItem("pushPort") || 15674
				this.formData.deviceName = localStorage.getItem("deviceName")
				this.formData.mac = localStorage.getItem("mac")
				this.formData.layout = localStorage.getItem("layout") || '1'
				this.$refs.modal.open()
			},
			async submit() {
				//表单验证
				if (!await this.$refs.settingForm.validate()) {
					return false
				}
				//存入缓存
				Object.keys(this.formData).forEach(key => {
					let val = this.formData[key]
					localStorage.setItem(key, val || '')
				})
				this.$message.success("设置成功！")
				location.reload()
				return true
			}
		}
	};
</script>
<style lang="less" scoped>

</style>